import { rateLimitedFetchAuthSession } from "@/setup/frontend/fetchAuthSession";

// @TODO review the location of this file
export async function getCommonFetchHeaders() {
	const session = await rateLimitedFetchAuthSession().catch(() => null);
	const token = session?.tokens?.accessToken.toString();
	return {
		Authorization:
			token && token !== "undefined" ? `Bearer ${token}` : undefined,
	} as Record<string, string>;
}
